module.exports = __webpack_public_path__ + "img/04.7ac452ed.jpg";